/** @typedef {{ error?: string, code?: string }} ApiErrorBody */

export const PLATFORM_ERROR_MARKERS = [
  'FUNCTION_INVOCATION_FAILED',
  'A server error has occurred',
  'FUNCTION_INVOCATION_TIMEOUT',
];

export const API_ERROR_MESSAGES = {
  SERVICE_NOT_READY: 'Service is temporarily unavailable. Please try again in a few moments.',
  SESSION_STORE_UNAVAILABLE:
    'We could not complete sign-in right now. Please try again in a few moments.',
  INVITE_STORE_UNAVAILABLE:
    'We could not complete sign-in with this invitation. Please try again in a few moments.',
  DATA_STORE_READONLY:
    'We could not complete this analysis right now. Please try again in a few moments.',
};

export function isPlatformInvocationFailure(text) {
  if (!text || typeof text !== 'string') return false;
  const t = text.trim();
  return PLATFORM_ERROR_MARKERS.some((m) => t.includes(m));
}

/**
 * @param {string} apiPath e.g. /auth/login
 * @param {ApiErrorBody | null} parsed
 * @param {string} rawText
 */
export function resolveClientErrorMessage(apiPath, parsed, rawText) {
  const code = parsed && parsed.code;
  if (code && API_ERROR_MESSAGES[code]) {
    return API_ERROR_MESSAGES[code];
  }
  if (parsed && typeof parsed.error === 'string' && parsed.error.trim()) {
    return parsed.error.trim();
  }
  if (isPlatformInvocationFailure(rawText)) {
    if (apiPath && apiPath.startsWith('/auth/')) {
      return 'We could not complete sign-in right now. Please try again in a few moments.';
    }
    return 'We could not complete this request right now. Please try again in a few moments.';
  }
  if (rawText && rawText.trim()) {
    return rawText.trim().slice(0, 200);
  }
  return 'Request failed';
}
